import Vue from 'www/vue_components'
import Vuetify from 'vuetify/lib/framework'
import * as directives from 'vuetify/lib/directives'
import { ru } from 'vuetify/lib/locale'

Vue.use(Vuetify, {
  directives,
})

const opts = {
  lang: {
    current: 'ru',
    locales: { ru },
  },
  theme: {
    disable: true,
  },
  icons: {
    iconfont: 'ui-icon',
    values: {
      next: 'ui-icon-arrow-right ui-icon-fz-smaller',
      prev: 'ui-icon-arrow-left ui-icon-fz-smaller',
      radioOn: 'ui-icon-radio-on',
      radioOff: 'ui-icon-radio-off',
      checkboxOn: 'ui-icon-checkbox-on',
      checkboxOff: 'ui-icon-checkbox-off',
      closeNotCircle: 'ui-icon-close-not-a-circle',
      emailIcon: 'ui-icon-at-sign',
      arrowDown: 'ui-icon-arrow-down',
      clear: 'ui-icon-close-not-a-circle',
    },
  },
}

export default new Vuetify(opts)
